import {
    Card,
    CardHeader,
    Container,
    Grid,
    Typography,
} from '@mui/material';
import {PLButton} from './PLFields';
import React from 'react';

export const Error404 = (props) => (
    <Error hasError={true} errorMessage="Oops! Page not found!"></Error>
);

export const Error = (props) => {
    return (
        <Container>
            <Typography variant="h3">{props.errorMessage}</Typography>
            {props.errorAdditionalDetail && (
                <Typography>{props.errorAdditionalDetail}</Typography>
            )}
        </Container>
    );
};

export interface ErrorCardProps {
    errorCode: number;
    recordType: string;
    closeFn?: () => void;
}

export const ErrorCard = (props: ErrorCardProps) => {
    let errorText = '';

    if (props.errorCode === 401 || props.errorCode === 403) {
        errorText =
            'You are not authorized to view this ' + props.recordType + '.';
    } else if (props.errorCode === 404) {
        errorText = 'This ' + props.recordType + ' does not exist.';
    } else if (props.errorCode === 500) {
        errorText =
            'An error occurred while loading this ' +
            props.recordType +
            '. Please close this tab and try again.';
    }

    return (
        <Card>
            <CardHeader
                title={
                    <Grid container justifyContent="space-between">
                        <Grid item flexGrow={2}>
                            <Grid container justifyContent="space-evenly">
                                <Grid item xs={12} md={6} lg={4} flexGrow={1}>
                                    <Typography variant="h6">
                                        {errorText}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <PLButton color="secondary" onClick={props.closeFn}>
                                Close
                            </PLButton>
                        </Grid>
                    </Grid>
                }></CardHeader>
        </Card>
    );
};
